module.exports = __webpack_public_path__ + "static/media/terms.2a437c23.md";